import { ModuleWithProviders, NgModule } from '@angular/core';
import { ResizeHtmlImagesPipe, ResizePipe } from './pipes';
import { ImageComponent } from './components/image/image.component';
import { ImageProcessorConfig, defaultConfig } from './models';
import { ImageConfigService } from './services/image-config.service';

@NgModule({
  exports: [ResizePipe, ResizeHtmlImagesPipe, ImageComponent],
  imports: [ResizePipe, ResizeHtmlImagesPipe, ImageComponent],
})
export class ImageModule {
  static forRoot(config: Partial<ImageProcessorConfig>): ModuleWithProviders<ImageModule> {
    return {
      ngModule: ImageModule,
      providers: [
        {
          provide: ImageConfigService,
          useValue: { ...defaultConfig, ...config },
        },
        {
          provide: ImageProcessorConfig,
          useValue: { ...defaultConfig, ...config },
        },
      ],
    };
  }
}
